module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    on: {
      "click": _vm.addressTap
    }
  }, [(_vm.addressInfo) ? _c('div', [_c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("收件人：" + _vm._s(_vm.addressInfo.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addressInfo.mobileNumber))])]) : _vm._e(), _vm._v(" "), (!_vm.addressInfo) ? _c('div', [_vm._m(0), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.addressInfo) ? _c('div', [_vm._v("\n            收货地址：" + _vm._s(_vm.addressInfo.area) + " " + _vm._s(_vm.addressInfo.location) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.addressInfo) ? _c('div', [_vm._v("\n            收货地址：\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "peisong "
  }, [_c('popup', {
    attrs: {
      "height": "50%"
    },
    on: {
      "on-first-show": _vm.resetScroller
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('header', {
    staticClass: "vux-1px-b"
  }, [_vm._v("配送地址"), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.show1 = false
      }
    }
  })]), _vm._v(" "), _c('scroller', {
    ref: "scroller",
    attrs: {
      "lock-x": "",
      "height": _vm.boxHeight
    }
  }, [_c('div', _vm._l((_vm.list), function(item, index) {
    return (_vm.list) ? _c('div', {
      key: index,
      staticClass: "box vux-1px-b",
      on: {
        "click": function($event) {
          _vm.addressListTap(item)
        }
      }
    }, [_c('div', [_c('span', [_c('i', {
      staticClass: "iconfont icon-weizhi"
    }), _vm._v("收件人：" + _vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.mobileNumber))])]), _vm._v(" "), _c('div', [_vm._v("\n                                    收货地址：" + _vm._s(item.area) + " " + _vm._s(item.location) + "\n                                ")]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-youjiantou-copy"
    })]) : _vm._e()
  }))])], 1), _vm._v(" "), (_vm.list.length) ? _c('button', {
    on: {
      "click": _vm.toShippAddress
    }
  }, [_vm._v("管理我的地址")]) : _c('router-link', {
    attrs: {
      "tag": "footer",
      "to": {
        name: 'AddAddress',
        params: {
          pathName: 'add'
        }
      }
    }
  }, [_c('b', [_c('i', {
    staticClass: "iconfont icon-jia"
  })]), _vm._v("新增收货地址")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("请填写收货地址")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7215118d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateOrder/BuyerAddress.vue
// module id = 579
// module chunks = 0